import FullBlock from "../Block/FullBlock";
import { myThoughtsDetails, ventureCapitalDetails } from "../../data/ventureCapital";

export default function VentureCapitalBlock() {
    return (
        <section>
            <div>
                {TitleLists.map((detail) => {
                    const { header, detailsName,logo } = detail;
                    return (
                        <FullBlock
                            header={header}
                            detailsName={detailsName}
                            logo={logo}
                        />
                    )
                })}
            </div>
        </section>

    )
}

const TitleLists = [
    {
        header: "My Thoughts on VC",
        detailsName: myThoughtsDetails,
        logo:require("../../images/Commons/thoughts.png"),
    },
    {
        header: "Personal Project",
        detailsName: ventureCapitalDetails,
        logo:require("../../images/Commons/rocket.png"),
    },


]
